import { render, staticRenderFns } from "./AppConfirmDeleteModal.vue?vue&type=template&id=bd117b8e&"
import script from "./AppConfirmDeleteModal.vue?vue&type=script&lang=js&"
export * from "./AppConfirmDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports